import React, { useEffect, useState } from "react";
import { numberOfEmployees } from "../../../util/CommonLists";
import * as services from "../../../store/service";
import * as MyAccountActions from "../../../store/myAccount/actions";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";

interface IProps {
    closeDialog: any;
}
const EmployeeRangeUpdateDialog: React.FunctionComponent<IProps> = (props: IProps) => {
    const dispatch = useDispatch();
    const [numberOfEmployeesValue, setNumberOfEmployeesValue] = useState("1-99");
    const getAccountInformation = () => dispatch(MyAccountActions.actionCreators.getAccountInformation(true));
    const closeEmployeeUpdateDialog = () => {
        services.updateEmployeeRange({ numberOfEmployees: numberOfEmployeesValue }).then((res: any) => {
            getAccountInformation();
            props.closeDialog();
        });
    };
    const { t: tLang } = useTranslation();

    useEffect(() => {
        services.updateEmployeeRange({ numberOfEmployees: "1-99" }).then((res: any) => {});
    }, []);

    return (
        <React.Fragment>
            <div className="dialog-header">
                <div className="dialog-icon">
                    <em className="las la-user"></em>
                </div>
                <h1>{tLang("manageAccount.protectionPlan.noOfemployee")}</h1>
            </div>

            <div className="dialog-body">
                <div className="form-row inline row">
                    <p>{tLang("manageAccount.protectionPlan.employeeRangeUpdatePopup.pleaseSelectMsg")}</p>
                </div>
                <div className="line-divider margin-vertical-xs"></div>

                <div className="form-row data-grid has-lines row-height-sm">
                    <div className="form-row inline row">
                        <div className="form-label col-xs-12 col-sm-4 col-no-gutter">
                            <label htmlFor="plan-employees">{tLang("manageAccount.protectionPlan.noOfemployee")}</label>
                        </div>
                        <div className="form-input col-xs-12 col-sm-4 col-no-gutter">
                            <select
                                className="inputbox"
                                id="plan-employees"
                                name="numberOfEmployees"
                                defaultValue={numberOfEmployeesValue}
                                onChange={(e) => {
                                    setNumberOfEmployeesValue(e.target.value);
                                }}
                            >
                                {numberOfEmployees.map((range: any, index: number) => (
                                    <option key={`range-${index}`} value={range}>
                                        {range}
                                    </option>
                                ))}
                            </select>
                        </div>
                    </div>
                </div>
            </div>

            <div className="dialog-footer">
                <div className="row between-xs">
                    <div className="col-xs col-no-gutter flex-grow-null"></div>
                    <div className="col-xs col-no-gutter flex-grow-null">
                        <button
                            type="submit"
                            className="btn-default btn-primary"
                            id="btn-submit-purchase"
                            onClick={() => {
                                closeEmployeeUpdateDialog();
                            }}
                        >
                            <span className="btn-text">{tLang("manageAccount.protectionPlan.btn.continue")}</span>
                        </button>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};
export default EmployeeRangeUpdateDialog;
